// Small shared blob helper used when attaching generated files (the journey
// summary PDF) to emails. The completion certificate PNG this file used to
// generate was removed at the company's request — it added no value beyond
// the PDF summary, which already covers everything the employee saw.

/** Convert a Blob to a base64 string (no data: prefix) for email attachments. */
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = (reader.result as string) || "";
      const idx = result.indexOf("base64,");
      resolve(idx >= 0 ? result.slice(idx + 7) : "");
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}
